import { Box, Typography } from "@mui/material";
import { PointsActionCodeRedemptionCompleted } from "@t3/shared";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import { BaseTransactionCard } from "./BaseTransactionCard";
import { DateDisplay, PointsBadge } from "./TransactionCardComponents";

interface CodeRedemptionCardProps {
  action: PointsActionCodeRedemptionCompleted;
  createdAt: string;
}

export const CodeRedemptionCard = ({
  action,
  createdAt,
}: CodeRedemptionCardProps) => {
  const typeMeta = action.typeMeta;
  // Fallback for old data that might not have points
  const pointsDisplay = typeMeta.points ?? "—";

  return (
    <BaseTransactionCard minHeight={120}>
      <Box display="flex" flexDirection="column" height="100%">
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="flex-start"
          mb="auto"
        >
          <Box display="flex" alignItems="center" gap={1.5}>
            <Box
              sx={{
                bgcolor: "#e3f2fd",
                width: 48,
                height: 48,
                borderRadius: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CardGiftcardIcon
                sx={{
                  color: "#1976d2",
                  fontSize: "1.75rem",
                }}
              />
            </Box>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 600,
                color: "text.primary",
              }}
            >
              Code Redeemed
            </Typography>
          </Box>
          <PointsBadge points={pointsDisplay} label="" variant="rewarded" />
        </Box>
        <Box mt={1.5}>
          <DateDisplay date={createdAt} />
        </Box>
      </Box>
    </BaseTransactionCard>
  );
};
